import {
  Component,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { LookupService, CorrectYeKeService } from "projects/sepidz-web-framework/src/lib/services";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GroupDescriptor, State, process } from "@progress/kendo-data-query";
import {
  GridDataResult,
  DataStateChangeEvent,
  GridComponent,
  SelectAllCheckboxState,
  SelectableMode,
  SelectionEvent,
  GroupKey,
  PageSizeItem,
  RowArgs,
} from "@progress/kendo-angular-grid";
import { delay, takeUntil } from "rxjs/operators";
import { SelectorService } from "../base/selector.service";
import { HttpCommonService, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services/http-common.service";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}

@Component({
  selector: "st-lookup",
  templateUrl: "./lookup.component.html",
  styleUrls: ["./lookup.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LookupComponent extends BaseControlComponent<any> {
  public pageSizes: PageSizeItem[] = [
    {
      text: "5",
      value: 5,
    },
    {
      text: "10",
      value: 10,
    },
    {
      text: "15",
      value: 15,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: this.translate.instant("ClientApp.Projects.FrameWorkShell.Shared.Controls.LookUp.All"),
      value: "all",
    },
  ];
  dataStateChanged: boolean = false;
  public gridView: GridDataResult;
  isshow: boolean;
  filterTimeout: number;
  public expandedGroupKeys: Array<GroupKey> = [];
  customWidth: number;
  _idName: string;
  temporaryData: any[];
  @Input() set idName(value: string) {
    this._idName = value;
  }
  get idName(): string {
    return this._idName ?? `lkp${this.name}`;
  }
  @Input() class: string;
  @Input() isModalParent: any;
  @Input() defaultSortKey: string;
  @Input() defaultSortKeyKind: "asc" | "desc" = "desc";
  @Input() filtering: boolean = false;
  @Input() filterLookUp: any[] = [];
  selectedRows: any[] = [];
  groupable: boolean = true;
  public groups: GroupDescriptor[] = [];
  public mySelection: number[] = [];
  defaultPageHeight: number = 300;
  @Input() pageHeight: number = 300;
  @Output() CompleteData = new EventEmitter<any>();
  myVar: any;
  loadTime: number = 0;
  public mode: SelectableMode = "multiple";
  public selectAllState: SelectAllCheckboxState = "unchecked";
  previesValue: any;
  top: string;
  left: string;
  right: string;
  isInside: boolean;

  @HostListener("window:keyup", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (document.hidden || !this.openToggle) return;
  }
  public isRowSelected = (e: RowArgs) => this.mySelection.indexOf(e.dataItem.Id) >= 0;
  @HostListener("window:keydown", ["$event"])
  @HostListener("keydown.arrowUp", ["$event"])
  @HostListener("keydown.escape", ["$event"])
  @HostListener("keydown.arrowDown", ["$event"])
  @HostListener("keydown.tab", ["$event"])
  cArrowDown(e: KeyboardEvent) {
    if (document.hidden || (document.activeElement.id && document.activeElement.id !== this.idName)) return;
    if (document.activeElement.innerHTML.includes("kendo.grid.gridLabel")) return;
    if (e.key === "ArrowDown") {
      if (this.openToggle && this.grid) this.grid.focus();
    } else if (e.key === "ArrowUp") {
      if (this.openToggle && this.grid) this.grid.focus();
    } else if (
      e.key !== "ArrowLeft" &&
      e.key !== "ArrowRight" &&
      e.key !== "Tab" &&
      e.key !== "Alt" &&
      document.getElementById(this.idName) &&
      this.openToggle
    )
      document.getElementById(this.idName).focus();
    if ((e.key === "ArrowUp" && e.altKey) || e.key === "Escape") {
      if (this.openToggle) {
        if (this.openToggle) {
          this.closePopOver();
          if (this.selectedRows?.length > 1) this.onRowsSelected.emit(this.selectedRows);
        }
      }
      e.returnValue = false;
      e.preventDefault();
      e.stopPropagation();
    }

    if (e.altKey && e.key === "ArrowDown" && document.getElementById(this.idName) === document.activeElement) {
      if (this.searchValue && this.searchValue?.length >= 0) this.refreshData();
      this.openPopover();
      e.preventDefault();
    }

    if (e.key === "Tab") {
      if (this.selectedRows?.length > 1) this.onRowsSelected.emit(this.selectedRows);
      if (this.searchValue && this.searchValue?.length >= 0) {
        this.refreshData();
        e.preventDefault();
      }
    }
  }
  bindable: boolean = false;
  orignalData: any[];
  setGrid_View() {
    if (this.selectorService.getDataList(this.name) && this.selectorService.getDataList(this.name)?.length <= 0) {
      this.gridView = process(this.selectorService?.getDataList(this.name) as any[], this.state);
      this.gridView.total = this.selectorService?.getDataList(this.name)?.length;
      this.bindable = !this.state.filter || this.state?.filter?.filters?.length <= 0;
      this.orignalData = this.selectorService?.getDataList(this.name) as any[];
      this.fitColumns();
      return;
    }
    if (this.selectorService.getDataList(this.name)) {
      this.state.take = this.selectorService.getDataList(this.name)?.length;
      this.loading = false;
      if (this.state.group && this.state.group?.length > 0)
        this.gridView = process(this.selectorService.getDataList(this.name) as any[], {
          group: this.state.group,
          sort: this.state.sort,
          filter: this.state.filter,
          take: this.state.take,
        });
      else this.gridView = process(this.selectorService.getDataList(this.name) as any[], this.state);
      this.gridView.total = this.selectorService.getDataList(this.name)?.length;
      this.bindable = !this.state.filter || this.state.filter.filters?.length <= 0;
      this.orignalData = this.selectorService.getDataList(this.name) as any[];
      this.fitColumns();

      this.cd.markForCheck();
      if ((!this.grid || !this.grid.data || this.grid.data["total"] <= 0) && this.gridView && this.gridView.data?.length > 0) {
        this.loading = false;
        let temp = Object.assign({}, this.gridView);
        this.gridView = process(temp.data as any[], {
          group: this.state.group,
          sort: this.state.sort,
          filter: this.state.filter,
          take: this.state.take,
        });
        if (!this.gridView.data || this.gridView.data?.length !== temp.data?.length) this.gridView.data = temp.data;
        this.gridView.total = temp.total;
        if (this.grid) this.grid.data["total"] = this.gridView.total;
        this.fitColumns();
      }
      this.setGridData();
      return;
    } else if (!this.gridView && this.dataList && this.dataList?.length > 0) {
      this.loading = false;
      this.state.take = this.dataList?.length;
      this.gridView = process(this.dataList as any[], {
        group: this.state.group,
        sort: this.state.sort,
        filter: this.state.filter,
        take: this.state.take,
      });
      if (!this.gridView.data || this.gridView.data?.length !== this.dataList?.length) this.gridView.data = this.dataList;
      this.orignalData = this.dataList;
      this.gridView.total = this.dataList?.length;
      this.fitColumns();
      this.setGridData();
      return;
    }

    if (
      this.bindable &&
      this.isFiltering &&
      this.searchValue !== undefined &&
      this.searchValue?.length > 0 &&
      this.gridView !== undefined &&
      this.gridView.data?.length > 0
    ) {
      var columns = this.textColumnsName.split(",");

      let _list: any[] = this.gridView.data as [];
      if (columns?.length >= 3)
        _list = _list.filter(
          (f) =>
            f[columns[0]].toString().includes(this.searchValue) ||
            f[columns[1]].toString().includes(this.searchValue) ||
            f[columns[2]].toString().includes(this.searchValue)
        );
      else if (columns?.length >= 2)
        _list = _list.filter((f) => f[columns[0]].toString().includes(this.searchValue) || f[columns[1]].toString().includes(this.searchValue));
      else _list = _list.filter((f) => f[this.textFieldName].toString().includes(this.searchValue));
      this.gridView = process(_list as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter, take: this.state.take });
      this.gridView.total = _list?.length;
      this.isFiltering = false;
      this.fitColumns();
      return;
    }
    if ((!this.grid || !this.grid.data || this.grid.data["total"] <= 0) && this.gridView && this.gridView.data?.length > 0) {
      this.loading = false;
      let temp = Object.assign({}, this.gridView);
      this.gridView = process(temp.data as any[], {
        group: this.state.group,
        sort: this.state.sort,
        filter: this.state.filter,
        take: this.state.take,
      });
      if (!this.gridView.data || this.gridView.data?.length !== temp.data?.length) this.gridView.data = temp.data;
      this.gridView.total = temp.total;
      if (this.grid) this.grid.data["total"] = this.gridView.total;
      this.fitColumns();
      return;
    }
    if (this.gridView && this.gridView.data?.length > 0) this.loading = false;
    if (!this.filtering)
      this.filtering =
        (this.dataList !== undefined && this.dataList !== null && this.dataList?.length > 0) ||
        (this.selectorService.getDataList(this.name) !== undefined && this.selectorService.getDataList(this.name)?.length > 0);
  }
  @Input() getdataList: (apiName: string, valueFieldName) => Observable<any[]>;
  @Input() shouldBeChangedData: (columnName: string) => boolean;
  @Input() onDataStateChange: (columnName: string, searchValue: string, skip: number, take: number) => Observable<PagingDataResult<any>>;
  _isMulti: boolean = false;
  @Input() get isMulti() {
    return this._isMulti;
  }
  set isMulti(value: boolean) {
    this._isMulti = value;
  }
  @Input() isPaging: boolean = false;
  @Input() groupsName: string;
  @Input() autocomplete: string = "off";
  searchValue: string = "";
  isFiltering: boolean = false;
  openToggle: boolean = false;
  _currentValue: string;
  @Input()
  set currentValue(value: string) {
    if (this.selectorService.getDisabledValue(this.name) === true) this._currentValue = this.selectorService.getDisabledValue(this.name);
    this._currentValue = value;
  }
  get currentValue(): string {
    if (!this.f[this.name]?.value && this._currentValue && this.SelectRow) {
      this.SelectRow = {};
      this._currentValue = undefined;
    }
    if (this.f[this.name]?.value && !this._currentValue) this.setCurrentValue();

    if (this.gridView && this.gridView.data && this.gridView.data?.length > 0 && this.f[this.name]?.value) {
      this.SelectRow = this.gridView.data.find((x) => x[this.valueFieldName] === this.f[this.name].value);
      if (this.SelectRow) {
        this._currentValue = this.SelectRow[this.textFieldName];
      }
    }
    return !this._currentValue ? "" : this._currentValue;
  }
  SelectRow: any;
  @Input() columns: form_control[] = [];
  @Input() orignalColumns: form_control[] = [];
  get _orignalColumns() {
    if (this.selectorService.getColumns(this.name) && this.selectorService.getColumns(this.name)?.length > 0)
      return this.selectorService.getColumns(this.name);
    return this.orignalColumns;
  }
  _paretnIdValue: number;
  _parentIdName: string;
  _dataList: any[];
  @Input() set dataList(value: any[]) {
    this._dataList = value;
    this.setGrid_View();
  }
  get dataList(): any[] {
    return this._dataList;
  }
  orignalList: any[];
  @Input() parentIdName: string;

  loading = false;
  @Output() onRowsSelected = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  public state: State = {
    skip: 0,
    take: 5,
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
    //SortColumn : "",
  };

  ngAfterViewChecked() {
    if ((this.f[this.name]?.value !== undefined && this.f[this.name]?.value !== null) || this.searchValue) {
      this.isshow = true;
    }
    this.height = this.defaultHeight;
    this.marginbottom = this.defaultHeight - 25;
  }

  show() {
    this.isshow = !this.isshow;
  }
  focusFunction() {
    if (this.openToggle) this.openToggle = true;
    this.isshow = true;
  }
  focusOutFunction() {
    if ((!this.f[this.name]?.value || this.f[this.name]?.value === "") && (!this.searchValue || this.searchValue === "")) {
      this.isshow = false;
    } else {
      this.isshow = true;
    }
  }
  @ViewChild("lookupGgrid") public grid: GridComponent;
  @ViewChild("inp") inpElement: ElementRef;
  constructor(
    private _httpCommonService: HttpCommonService,
    private lookupservice: LookupService,
    private translate: TranslateService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    window.removeEventListener("scroll", this.scroll, true);
    this.onDataStateChange = null;
    this.selectedRows = undefined;
    this.mySelection = undefined;
  }
  scroll = (event): void => {
    const currentPos = this.top;
    setTimeout(() => {
      this.setPositionPopover();
      this.cd.markForCheck();
      if (currentPos !== this.top) this.closePopOver();
    }, 100);
    //}

    //if (!this.isInside) {
    //  if (this.openToggle) {
    //    this.openToggle = false;
    //    this.cd.markForCheck();
    //    setTimeout(() => {
    //      this.openToggle = true;
    //    }, 50);

    //    this.top = 'auto';
    //    if (this.openToggle) {
    //      setTimeout(() => {
    //        this.setPositionPopover();
    //        this.cd.markForCheck();
    //      }, 100);
    //    }
    //  }
    //}
  };
  ngOnInit() {
    super.ngOnInit();
    this.selectorService.onDataListChanged.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      this.setGrid_View();
    });
    window.addEventListener("scroll", this.scroll, true); //third parameter
    if (!this.pageHeight) this.pageHeight = this.defaultPageHeight;
    else if (this.defaultPageHeight !== this.pageHeight) this.pageHeight = this.defaultPageHeight * this.pageHeight;
    this.loading = false;
    this.setColumns();
    if (this.name && this.f && this.f[this.name]) {
      this.f[this.name]?.valueChanges?.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        this.currentValue = x;
        this.setCurrentValue();
      });
    }
    if (this.isPaging === true && this.onDataStateChange !== undefined) this.isPaging = true;
    else
      this.isPaging =
        this.selectorService.getDataStateChange(this.name) !== undefined ||
        !this.apiName ||
        this.apiName.includes("Paging") ||
        this.apiName.includes("Pagining");
    if (this.isMulti) this.mode = "multiple";
    else this.mode = "single";
    if (!isNullOrUndefined(this.groupsName)) {
      this.groups = [];
      let groups = this.groupsName.split(",");
      groups.forEach((x) => {
        this.groups.push({ field: x });
      });
      this.state.group = this.groups;
      this.groupable = this.groups?.length > 0;
    }
    this.bindable =
      !this.isPaging ||
      this.groups?.length > 0 ||
      (this.dataList !== undefined && this.dataList !== null && this.dataList?.length > 0) ||
      (this.selectorService.getDataList(this.name) !== undefined && this.selectorService.getDataList(this.name)?.length > 0);
    this.refreshData();
  }
  async setColumns() {
    if (this.columns && this.columns?.length > 0) this.orignalColumns = this.columns;
    var columns = this.textColumnsName.split(",");
    if (this._orignalColumns && this._orignalColumns?.length > 0) {
      var c = this._orignalColumns.filter((f) => columns.some((c) => c === f.name)).sort((a, b) => a.order - b.order);
      this.columns = c;
      this.columns.map((x) => {
        if (!x.maxLength) x.listVisible = true;
      });
      this.setColumnWidth();
      return;
    }
    await this._httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.orignalColumns = data as form_control[];
            var c = (data as form_control[]).filter((f) => columns.some((c) => c === f.name)).sort((a, b) => a.order - b.order);
            this.columns = c;
            this.columns.map((x) => {
              x.listVisible = true;
            });
          }
        },
        (error) => (this.loading = false)
      );
    this.setColumnWidth();
  }
  getmodelName(name: string) {
    var modelName = this._orignalColumns.find((x) => x.name === name);
    if (modelName && modelName.modelName) return modelName.modelName;
    return name;
  }

  setDefaultSortKey() {
    if (this.defaultSortKey) {
      var keys = this.defaultSortKey?.split(",");
      this.state.sort = [];
      keys.forEach((x) => {
        this.state.sort.push({
          field: `${x}`,
          dir: this.defaultSortKeyKind,
        });
      });
    }
  }

  showClear(): boolean {
    const flag =
      this.name &&
      ((this.f[this.name] && this.f[this.name]?.value !== null && this.f[this.name]?.value !== undefined && this.f[this.name]?.value > 0) ||
        this.searchValue?.length > 0) &&
      !this.disabled;
    return flag;
  }
  clearValue() {
    this.isshow = false;
    this.SelectRow = undefined;
    if (this.f[this.name]?.value && !this.disabled) this.f[this.name].markAsDirty();
    this.f[this.name].setValue(undefined);
    this.valueChange.emit(this.f[this.name]?.value);
    this.valueChangeByApiName.emit({ data: undefined, apiName: this.apiName, KeyName: this.name });
    this._currentValue = "";
    this.searchValue = "";
    this.SelectRow = undefined;
    this.loading = false;
    if (this.onDataStateChange || this.selectorService.getDataStateChange(this.name)) this.setDataFromFunction();
    else this.refreshData();
  }
  setPositionPopover(event?) {
    // if (!document.getElementById("inputbox" + this.name)) return;
    // const pos = document.getElementById("inputbox" + this.name).getBoundingClientRect();
    // const popover = document.getElementById(this.name).getBoundingClientRect();
    // //const bodyWidth = document.documentElement.clientWidth;
    // const Modal = document.getElementsByTagName("simple-modal-wrapper");
    // if (pos.top < window.innerHeight / 2) {

    //   if (Modal?.length > 0) {
    //     this.top = pos.top + pos.height + "px";
    //   } else {
    //     if (pos.top < popover.top && popover.top - pos.top !== pos.height) {
    //       this.top = pos.top + pos.height + "px";
    //       if (pos.top - (50 - pos.height) <= 0) {
    //         this.top = "auto";
    //       }
    //     }
    //   }
    // } else {
    //   if (Modal?.length > 0) this.top = pos.top + popover.height + "px";
    //   else this.top = pos.top - (popover.height + 80) + "px";
    // }
    // if (popover.left < 0) {
    //   this.left = 0 + "px";
    // } else {
    //   this.left = null;
    // }
    // if (popover.right < 0) {
    //   this.right = 0 + "px";
    // } else {
    //   this.right = null;
    // }
    // const selectRect: ClientRect = modal.getBoundingClientRect();
    // const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // const offsetTop = selectRect.top + window.pageYOffset;
    // const height = selectRect.height;
    // const dropdownHeight = dropdownEl.getBoundingClientRect().height;
    // if ((offsetTop + height + dropdownHeight+100) > (scrollTop + document.documentElement.clientHeight)) {
    //   return 'top';
    // } else {
    //   return 'bottom';
    // }
    this.cd.markForCheck();
  }
  private _calculateCurrentPosition(dropdownEl: HTMLElement) {}
  openPopover(onlyOpen: boolean = false) {
    if (this.disabled) return;
    if (!this.columns || this.columns.length <= 0) this.setColumns();
    if (this.openToggle && onlyOpen) return;
    if (this.openToggle && !onlyOpen) {
      if (this.selectedRows?.length > 1) this.onRowsSelected.emit(this.selectedRows);
      this.closePopOver();
      return;
    }
    this.loading = false;
    if (!this.apiName && this.dataList && this.dataList?.length > 0) {
      this.fitColumns();
      this.setGrid_View();
    }
    if (this.shouldBeChangedData && this.shouldBeChangedData(this.name)) {
      this._currentValue = undefined;
      this.searchValue = "";
      this.refreshData();
    } else if (!this.gridView || this.gridView.data?.length <= 0) this.refreshData();
    if (this.gridView && this.gridView.data?.length > 0 && (!this.grid?.data["total"] || this.grid?.data["total"] <= 0)) this.refreshData();
    if (!onlyOpen) this.openToggle = !this.openToggle;
    else this.openToggle = onlyOpen;
    //this.top = 'auto';
    if (this.openToggle) {
      this.setPositionPopover();
    }

    if (this.openToggle) {
      this.mySelection = [];
      this.fitColumns();
    } else {
      if (this.selectedRows?.length > 1) this.onRowsSelected.emit(this.selectedRows);
      this.closePopOver();
    }
    this.setGrid_View();
  }
  onResize(event) {
    if (this.openToggle) {
      // setTimeout(() => {
      this.setPositionPopover();
      this.cd.markForCheck();
      // }, 100);
    }
  }
  setDataFromFunction() {
    if (!this.loading) {
      if (this._currentValue || this.searchValue) {
        if (this._currentValue) this.searchValue = this._currentValue.toString();
      }
      if (!this.searchValue && this.f[this.name]?.value) this.searchValue = this.f[this.name].value;
      if (this.selectorService.getDataStateChange(this.name)) {
        this.loading = true;
        this.selectorService
          .getDataStateChange(this.name)(this.name, this.searchValue, this.state.skip, this.state.take)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.loading = false;
              if (x) {
                this.gridView = process(x.Data as any[], {
                  group: this.state.group,
                  sort: this.state.sort,
                  filter: this.state.filter,
                  take: this.state.take,
                });
                if (!this.gridView.data || this.gridView.data?.length != x.Data?.length) this.gridView.data = x.Data;
                this.gridView.total = x.TotalPage;
                this.setCurrentValue();
                this.fitColumns();
                this.setGridData();
              }
            },
            (error) => (this.loading = false)
          );
      } else {
        this.loading = true;
        this.onDataStateChange(this.name, this.searchValue, this.state.skip, this.state.take)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.loading = false;
              if (x && x.Data) {
                this.gridView = process(x.Data as any[], {
                  group: this.state.group,
                  sort: this.state.sort,
                  filter: this.state.filter,
                  take: this.state.take,
                });
                if (!this.gridView.data || this.gridView.data?.length != x.Data?.length) this.gridView.data = x.Data;
                this.gridView.total = x.TotalPage > 0 ? x.TotalPage : x.Data?.length;
                this.orignalData = x.Data as any[];
                this.setCurrentValue();
                this.setGridData();
                setTimeout(() => {
                  this.fitColumns();
                  this.setGrid_View();
                  if (this.openToggle && this.grid) {
                    if (!this.grid.data || this.grid.data["total"] <= 0) {
                      this.gridView = process(x.Data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
                      this.gridView.total = x.TotalPage;
                      if (this.grid) {
                        this.grid.data = this.gridView.data;
                        this.grid.data["total"] = this.gridView.total;
                      }
                    }
                  }
                }, 200);
              }
            },
            (error) => (this.loading = false)
          );
      }
    }
  }
  setGridData() {
    if (this.grid && (this.grid.data != this.gridView.data || this.grid.data["total"].length !== this.gridView.total)) {
      this.grid.data = this.gridView.data;
      this.grid.data["total"] = this.gridView.total;
      setTimeout(() => {
        this.cd.markForCheck();
      }, 200);
    } else if (!this.grid)
      setTimeout(() => {
        this.setGridData();
      }, 100);
  }
  async refreshData() {
    if (this.loading || this.selectorService.getDataList(this.name)) return;
    if (this.selectorService.getTakeValue(this.name)) {
      this.state.take = this.selectorService.getTakeValue(this.name);
    }
    this.setDefaultSortKey();
    if (this.getdataList) {
      this.loading = true;
      await this.getdataList(this.apiName, this.valueFieldName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (x) => {
            if (x) {
              this.orignalList = x as any[];
              this.isFiltering = false;
              this.gridView = process(x as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
              this.gridView.total = x?.length;
              this.grid.data = this.gridView.data;
              this.grid.data["total"] = this.gridView.total;
              setTimeout(() => {
                this.fitColumns();
                this.setGrid_View();
              }, 10);
              this.setGridData();
            }
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.isFiltering = false;
          }
        );
    }
    if (!this.apiName && this.dataList && this.dataList?.length > 0) {
      this.fitColumns();
      this.setGrid_View();
    } else if (this.apiName) {
      if (this.onDataStateChange || this.selectorService.getDataStateChange(this.name)) {
        this.setDataFromFunction();
        return;
      }
      if (!this.systemName && !this.category) {
        if (this.isPaging) {
          let temp = this.textColumnsName.split(",");
          let temp2 = this.textColumnsName.split(",");
          let columnsName: string;
          if (this.searchValue) {
            temp2 = [];
            temp.forEach((x) => {
              temp2.push(this.getmodelName(x));
            });
            columnsName = temp2.join();
          } else if (this.f[this.name]?.value && !this.searchValue) {
            columnsName = this.valueFieldName;
            this.searchValue = this.f[this.name].value.toString();
          }
          this.loading = true;
          //if (this.searchValue)
          //  this.state.skip = 0;
          await this._httpCommonService
            .GetPagining<PagingDataResult<any>>(this.apiName, columnsName, this.searchValue, this.state.skip, this.state.take)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (x: PagingDataResult<any>) => {
                if (x) {
                  if (this.filterLookUp && this.filterLookUp?.length > 0 && this.apiName.includes("Warehouse/GetPagining")) {
                    this.filterLookUp.map((s: { key: string; value: boolean }) => {
                      this.temporaryData = x.Data?.filter((c) => c[s.key] === s.value);
                    });
                    x.Data = this.temporaryData;
                  }
                  
                  this.isFiltering = false;
                  this.loading = false;
                  this.gridView = process(x?.Data as any[], {
                    group: this.state.group,
                    sort: this.state.sort,
                    filter: this.state.filter,
                    take: this.state.take,
                  });
                  if (!this.gridView.data || this.gridView.data?.length != x.Data?.length) this.gridView.data = x.Data;
                  this.gridView.total = x.TotalPage;
                  this.setCurrentValue();
                  this.setGridData();
                  setTimeout(() => {
                    this.fitColumns();
                    this.setGrid_View();
                    if (this.openToggle && this.grid) {
                      if (!this.grid.data || this.grid.data["total"] <= 0) {
                        this.gridView = process(x.Data as any[], { group: this.state.group, sort: this.state.sort, filter: this.state.filter });
                        this.gridView.total = x.TotalPage;
                        this.grid.data = this.gridView.data;
                        this.grid.data["total"] = x.TotalPage;
                      }
                    }
                    this.CompleteData.emit({ apiName: this.apiName, data: x.Data });
                  }, 200);
                }
              },
              (error) => {
                this.loading = false;
                this.isFiltering = false;
              }
            );
        } else {
          if (!this.dataList || this.dataList?.length <= 0) {
            this.loading = true;
            if (this.gridView && this.gridView.data && this.orignalList && this.gridView.data?.length === this.orignalList?.length) {
              if (this.f[this.name]?.value && !this.searchValue) {
                //columnsName = this.valueFieldName;
                this.searchValue = this.f[this.name].value.toString();
              }
              let data: any[] = Object.assign([], this.orignalList);

              let temp = this.textColumnsName.split(",");
              if (this.searchValue) {
                data = data.filter(
                  (f) =>
                    (temp && temp?.length >= 1 && f[temp[0]].includes(this.searchValue)) ||
                    (temp && temp?.length >= 2 && f[temp[1]].includes(this.searchValue)) ||
                    (temp && temp?.length >= 3 && f[temp[2]].includes(this.searchValue)) ||
                    (temp && temp?.length >= 4 && f[temp[3]].includes(this.searchValue))
                );
              }
              this.gridView = process(data, { group: this.state.group, sort: this.state.sort, filter: this.state.filter, take: this.state.take });
              this.gridView.total = data?.length;
              this.loading = false;
              this.setCurrentValue();
              this.setGridData();
              this.fitColumns();
              return;
            }
            await this._httpCommonService
              .getList(this.apiName)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (data: any[]) => {
                  this.isFiltering = false;
                  this.orignalList = data as any[];
                  this.gridView = process(data as any[], {
                    group: this.state.group,
                    sort: this.state.sort,
                    filter: this.state.filter,
                    take: this.state.take,
                  });
                  if (this.gridView.data.length <= 0 && data && data?.length > 0) this.gridView.data = data;
                  this.gridView.total = data?.length;
                  this.loading = false;
                  this.setCurrentValue();
                  this.setGridData();
                  this.fitColumns();
                  this.CompleteData.emit({ apiName: this.apiName, data: data });
                },
                (error) => {
                  this.loading = false;
                  this.isFiltering = false;
                }
              );
          }
        }
      } else if (!this.dataList || this.dataList?.length <= 0) {
        this.loading = true;
        this.lookupservice
          .getLookupbyCategory(this.systemName, this.category)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (data: any[]) => {
              this.gridView = process(data as any[], {
                group: this.state.group,
                sort: this.state.sort,
                filter: this.state.filter,
                take: this.state.take,
              });
              this.gridView.total = data?.length;
              this.loading = false;
              this.isFiltering = false;
              this.setCurrentValue();
              this.setGridData();
              this.fitColumns();
            },
            (error) => {
              this.loading = false;
              this.isFiltering = false;
            }
          );
      }
    }
  }
  setColumnWidth() {
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      )
        x.format = "#,#.#####;(#,#.#####)";
      else x.format = "";
      if (!x.columnWidth || x.columnWidth <= 100) {
        if (x.textType === "text") x.columnWidth = 250;
        else x.columnWidth = 150;
      }
    });
  }
  setCurrentValue() {
    if (!this.gridView && this.dataList !== undefined && this.dataList !== null && this.dataList?.length > 0) {
      this.loading = false;
      this.gridView = {
        data: this.dataList,
        total: this.dataList?.length,
      };
      this.fitColumns();
    }

    if (!this.SelectRow && this.f[this.name]?.value) {
      if (!this.gridView || !this.gridView.data || this.gridView.data?.length <= 0) {
        if (!this.loading && this.f[this.name] && this.f[this.name]?.value && this.loadTime <= 2) {
          this.loadTime++;
          this.isFiltering = true;
          this.refreshData();
        }
      }
      if (this.gridView && this.gridView.data && this.gridView.data?.length > 0) {
        this.SelectRow = this.gridView.data.find((x) => x[this.valueFieldName] === this.f[this.name].value);
        if (this.SelectRow && this.SelectRow[this.valueFieldName]) {
          this._currentValue = this.SelectRow[this.textFieldName];
          if (this.f[this.name]?.value !== this.SelectRow[this.valueFieldName] && !this.disabled) this.f[this.name].markAsDirty();
          this.f[this.name].setValue(this.SelectRow[this.valueFieldName]);
          this.valueChange.emit(this.SelectRow[this.valueFieldName]);
          this.valueChangeByApiName.emit({ data: this.SelectRow, apiName: this.apiName, KeyName: this.name });
          this.onRowSelected.emit(this.SelectRow);
          if (this.openToggle) this.openToggle = false;
          this.searchValue = "";
        } else if (!this.loading && this.f[this.name] && this.f[this.name]?.value && this.loadTime <= 2) {
          this.loadTime++;
          this.isFiltering = true;
          this.refreshData();
        }
      }
    } else if (this.SelectRow && !this.isFiltering && this.SelectRow[this.textFieldName]) {
      this._currentValue = this.SelectRow[this.textFieldName];
      if (this.f[this.name]?.value !== this.SelectRow[this.valueFieldName] && !this.disabled) this.f[this.name].markAsDirty();
      if (this.f[this.name]?.value !== this.SelectRow[this.valueFieldName]) this.f[this.name].setValue(this.SelectRow[this.valueFieldName]);
      this.valueChange.emit(this.SelectRow[this.valueFieldName]);
      this.onRowSelected.emit(this.SelectRow);
      this.valueChangeByApiName.emit({ data: this.SelectRow, apiName: this.apiName, KeyName: this.name });
      this.searchValue = "";
    }
    if (
      this.searchValue !== undefined &&
      this.searchValue?.length > 0 &&
      this.searchValue !== this.f[this.name]?.value &&
      this.gridView &&
      !this.openToggle &&
      this.gridView.total > 1
    ) {
      this.mySelection = [];
      if (!this.disabled) this.openPopover();
      this.fitColumns();
    } else if (this.searchValue && this.searchValue?.length > 0 && this.gridView && this.gridView.total === 1) {
      this.SelectRow = this.gridView.data[0];
      if (this.SelectRow && this.SelectRow[this.valueFieldName]) {
        this._currentValue = this.SelectRow[this.textFieldName];
        if (this.f[this.name]?.value !== this.SelectRow[this.valueFieldName] && !this.disabled) this.f[this.name].markAsDirty();
        this.f[this.name].setValue(this.SelectRow[this.valueFieldName]);
        this.valueChange.emit(this.SelectRow[this.valueFieldName]);
        this.onRowSelected.emit(this.SelectRow);
        this.valueChangeByApiName.emit({ data: this.SelectRow, apiName: this.apiName, KeyName: this.name });
        if (this.openToggle) {
          this.closePopOver();
        }
        this.searchValue = "";
        this.cd.markForCheck();
      }
    }
    if (this.searchValue) this.isshow = true;
    this.cd.markForCheck();
  }
  public onUserRowSelect({ sender, column, rowIndex, columnIndex, dataItem }): void {
    this.SelectRow = dataItem;
    this.isFiltering = false;
    if (this.SelectRow && this.SelectRow[this.valueFieldName]) {
      this._currentValue = this.SelectRow[this.textFieldName];
      if (this.f[this.name]?.value !== this.SelectRow[this.valueFieldName] && !this.disabled) this.f[this.name].markAsDirty();
      this.f[this.name].setValue(this.SelectRow[this.valueFieldName]);
      this.onRowSelected.emit(this.SelectRow);
      this.valueChange.emit(this.SelectRow[this.valueFieldName]);
      this.valueChangeByApiName.emit({ data: this.SelectRow, apiName: this.apiName, KeyName: this.name });
      this.searchValue = "";
    }
    this.cd.markForCheck();
    this.closePopOver();
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.dataStateChanged = true;
    this.state.sort = state.sort.filter((x) => x.dir !== undefined);
    this.groups = state.group;
    if (this.onDataStateChange || this.selectorService.getDataStateChange(this.name)) {
      this.setDataFromFunction();
    } else {
      if (this.isPaging) this.refreshData();
    }
    if (this.openToggle) this.openToggle = false;
    this.top = "auto";
    this.openPopover();
    if (this.openToggle) {
      setTimeout(() => {
        this.setPositionPopover();
      }, 200);
    }
  }
  fitColumns(): void {
    setTimeout(() => {
      if (this.grid) {
        this.grid.autoFitColumns();
        const minColumnWidth = 90; // Set your desired minimum width here
        this.grid.columns?.forEach((column) => {
          if (column.width && column.width < minColumnWidth) {
            column.width = minColumnWidth;
          }
        });
      }
    }, 50);
    this.cd.markForCheck();
  }

  public onFilter(inputValue: string) {
    this.filterTimeout = new Date().getMilliseconds();
    this.isFiltering = true;
    this.searchValue = CorrectYeKeService.getCorrectYeKe(inputValue);
    setTimeout(async () => {
      this.loading = false;
      this.isFiltering = false;
      await this.refreshData();
    }, 500);
    this.isFiltering = false;
  }
  onGridSelectionChange(event: SelectionEvent) {
    if (this.isMulti) {
      event.selectedRows.forEach((x) => {
        this.selectedRows.push(x.dataItem);
      });
    }
  }
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === "unchecked" && this.mySelection?.length <= 0) {
      //this.mySelection = this.orignalData.map((item) => item.Id);
      this.onSelectedKeysChange(this.mySelection);
    } else {
      if (checkedState === "checked") {
        //this.mySelection = this.orignalData.map((item) => item.Id);
        this.selectAllState = "checked";
      } else {
        this.mySelection = [];
        this.selectAllState = "unchecked";
      }
    }
  }
  public onSelectedKeysChange(e) {
    const len = e?.length;
    this.isFiltering = false;
    if (len === 0) {
      this.selectAllState = "unchecked";
    } else if (len > 0 && len < this.gridView.total) {
      this.selectAllState = "indeterminate";
    } else {
      this.selectAllState = "checked";
    }
    if (this.isMulti) {
      this.mySelection = e;
      if (e && e?.length > 0) {
        this.selectedRows = this.orignalData?.filter((x) => e.some((s) => s === x.Id));
        if (!this.selectedRows) this.selectedRows = this.gridView?.data?.filter((x) => e.some((s) => s === x.Id));
      } else this.selectedRows = [];
    }

    if (!this.isMulti && e?.length === 1) {
      this.SelectRow = this.orignalData?.find((x) => x[this.valueFieldName] === e[0] || x["Id"] === e[0]);
      if (!this.SelectRow) this.SelectRow = this.gridView?.data?.find((x) => x[this.valueFieldName] === e[0] || x["Id"] === e[0]);
      this.setCurrentValue();
      this.closePopOver();
    }
    this.cd.markForCheck();
    this.show();
  }

  closePopOver() {
    if (this.openToggle) {
      this.openToggle = false;
      // this.top = "auto";
      this.cd.markForCheck();
    }
  }
  onKey() {
    if (this.openToggle) {
      if (this.selectedRows?.length > 1) this.onRowsSelected.emit(this.selectedRows);
      this.closePopOver();
    }
  }
  closeout() {
    setTimeout(() => {
      if (this.dataStateChanged) {
        this.dataStateChanged = false;
        return;
      }
      this.OkClicked();
      if (this.openToggle) {
        this.openToggle = false;
        // this.top = "auto";
        this.cd.markForCheck();
      }
    }, 100);
  }
  inside() {
    this.isInside = true;
  }
  OkClicked() {
    if (this.openToggle) {
      if (this.selectedRows?.length > 0) this.onRowsSelected.emit(this.selectedRows);
      else this.onRowSelected.emit(this.selectedRows[0]);
      this.closePopOver();
    }
  }
  CancelClicked() {
    this.closePopOver();
  }
  getSelctedChange(keyName: string, value: any) {
    if (!value) return false;
    let result = true;
    let items = this.orignalData.filter((x) => x[keyName] === value).map((item) => item.Id);
    items.forEach((item) => {
      if (!this.mySelection.some((s) => s === item)) result = false;
    });
    return result;
  }
  gridGroupHeader(keyName: string, value: any, checked: any) {
    let items = this.orignalData.filter((x) => x[keyName] === value).map((item) => item.Id);
    items.forEach((item) => {
      if (!this.mySelection.some((s) => s === item) && checked.target.checked) this.mySelection.push(item);
      else this.mySelection = this.mySelection.filter((f) => f !== item);
    });
    this.onSelectedKeysChange(this.mySelection);
    this.cd.markForCheck();
  }
}
